import { firstToCustomer, notResponseToClosed } from './filters'

export const averageFirstResponseTime = {
  analysisType: 'average',
  eventCollection: 'message.sent',
  filters: [firstToCustomer, notResponseToClosed],
  key: 'averageFirstResponseTime',
  targetProperty: 'time.since_first_last_message_received',
}
